import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { SpinnerComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'tellent-assistant-tool-pill',
  imports: [SpinnerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './tool-pill.component.html',
  styleUrl: './tool-pill.component.less',
})
export class TellentAssistantToolPillComponent {
  public readonly toolName = input.required<string>();
}
